import React from 'react'
import PropTypes from 'prop-types'

import Box from 'suitTheme/Box'

const Separator = (props) => {
  const { boxProps, children } = props

  return (
    <Box
      alignItems="center"
      backgroundColor="backgroundColor"
      borderBottom="1px solid"
      borderTop="1px solid"
      borderColor="lineColor"
      justifyContent="center"
      fontSize="small"
      marginLeft="-16px"
      marginRight="-16px"
      padding="small"
      width="calc(100% + 32px)"
      {...boxProps}
    >
      {children}
    </Box>
  )
}

Separator.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}

export default Separator
